import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Highcharts from 'highcharts';
import PatternFill from 'highcharts/modules/pattern-fill';
import BaseMultiSeriesLineOrAreaChart from '../utils/BaseMultiSeriesLineOrAreaChart';

// Register pattern-fill module for hatching on unexpected series
PatternFill(Highcharts);

const chartOptions = {
  tooltip: {
    pointFormatter() {
      // Pattern-fill series have object colors; extract the background color for the tooltip dot
      const dotColor =
        typeof this.color === 'string' ? this.color : this.series.options.color?.pattern?.backgroundColor || '#ccc';
      const isHovered = this.series.state === 'hover';
      const nameStyle = isHovered ? 'font-weight:bold;font-size:13px' : 'opacity:0.7';
      return `<div style="padding:1px 0;${isHovered ? 'background:rgba(255,255,255,0.08);margin:0 -4px;padding:1px 4px' : ''}">
        <span style="color:${dotColor}">●</span> <span style="${nameStyle}">${this.series.name}</span>: <b>${this.y.toFixed(1)}%</b><br/>
      </div>`;
    },
    sort: true
  },
  yAxis: {
    min: 0,
    max: 100,
    labels: {
      formatter() {
        return `${this.value}%`;
      }
    }
  }
};

@inject('$app', '$auth', '$dataviews')
@observer
class BgpReachabilityTimelineInner extends BaseMultiSeriesLineOrAreaChart {
  constructor(props) {
    super(props, { chartOptions });
  }
}

const ThemedInner = withTheme(BgpReachabilityTimelineInner);

// Wrapper that renders the chart
const BgpReachabilityTimeline = (props) => (
  <div>
    <ThemedInner {...props} />
  </div>
);

export default BgpReachabilityTimeline;
